import { FaSquareGithub,FaLinkedin,FaSquareFacebook } from  "react-icons/fa6";
import { SiGmail } from "react-icons/si";
import { Link } from "react-router-dom";

function Contact() {
    return(
      <main className="contact">
        <Link to="www.linkedin.com/in/yousif-ibrahim-23b27b313" target="_blank"><FaLinkedin/> Linkedin</Link>
        <Link to="https://www.facebook.com/share/tU2ntm7uAjnRZJxW/?mibextid=qi2Omg" target="_blank"><FaSquareFacebook/> Facebook</Link>
        <Link to="https://github.com/249joe" target="_blank"><FaSquareGithub/> Github</Link>
        <Link to="https://mail.google.com" target="_blank"><SiGmail/> j03ibra@gamil.com</Link>
      </main>
    )
}
export default Contact;
